import React, { useEffect, useState } from "react";
import { Box } from "native-base";
import Input from "../../../../../components/Input";
import ButtonPersonalizado from "../../../../../components/ButtonPersonalizado";

import Cards, { Focused } from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { Text as RNText, View as RNView } from "react-native";
import { Feather } from "@expo/vector-icons";
import { useTheme } from "../../../../../ThemeProvider";
import { corTextoSobre } from "../../../../theme/cores";

interface DadosPagamentoProps {
  getConfigEmpresa: any;
  nomeCartao: string;
  setNomeCartao: (value: string) => void;
  numeroCartao: string;
  setNumeroCartao: (value: string) => void;
  validadeCartao: string;
  setValidadeCartao: (value: string) => void;
  cvv: string;
  setCvv: (value: string) => void;
  onBack: () => void;
  onFinish: () => void;
  primaryColor?: string | null;
  etapaCartao: string;
  setEtapaCartao: (value: string) => void;
  // layout novo: a moldura (topo "‹" e botão do rodapé) chama as MESMAS
  // funções que os botões Voltar / Próximo / Finalizar chamavam aqui
  acoesRef?: React.MutableRefObject<any>;
  mensagemErro?: string;
}

const DadosPagamento: React.FC<DadosPagamentoProps> = ({
  getConfigEmpresa,
  nomeCartao,
  setNomeCartao,
  numeroCartao,
  setNumeroCartao,
  validadeCartao,
  setValidadeCartao,
  cvv,
  setCvv,
  onBack,
  onFinish,
  primaryColor,
  etapaCartao,
  setEtapaCartao,
  acoesRef,
  mensagemErro,
}) => {
  const [focusInput, setFocusInput] = useState<Focused | undefined>(undefined);

  const voltarCampo = () => {
    if (etapaCartao === "cvv") {
      setEtapaCartao("validade-cartao");
      return;
    }

    if (etapaCartao === "validade-cartao") {
      setEtapaCartao("nome-cartao");
      return;
    }

    if (etapaCartao === "nome-cartao") {
      setEtapaCartao("numero-cartao");
      return;
    }

    onBack();
  };

  useEffect(() => {
    if (etapaCartao === "numero-cartao") {
      setFocusInput("number");
      return;
    } else if (etapaCartao === "nome-cartao") {
      setFocusInput("name");
      return;
    } else if (etapaCartao === "validade-cartao") {
      setFocusInput("expiry");
      return;
    } else if (etapaCartao === "cvv") {
      setFocusInput("cvc");
    }
  }, [etapaCartao]);

  const proximoCampo = () => {
    if (etapaCartao === "numero-cartao") {
      setEtapaCartao("nome-cartao");
      return;
    }

    if (etapaCartao === "nome-cartao") {
      setEtapaCartao("validade-cartao");
      return;
    }

    if (etapaCartao === "validade-cartao") {
      setEtapaCartao("cvv");
    }
  };

  if (acoesRef) {
    acoesRef.current = {
      voltar: voltarCampo,
      proximo: etapaCartao === "cvv" ? onFinish : proximoCampo,
    };
  }

  const { primaryColor: corTema } = useTheme();
  const corFoco = corTema || primaryColor || undefined;
  const erroCampo = !!mensagemErro;

  const renderInputAtual = () => {
    if (etapaCartao === "numero-cartao") {
      return (
        <Input
          colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
          corBordaFiltro={"#e2e8f0"}
          mask="9999 9999 9999 9999"
          value={numeroCartao}
          styleBox={{ marginTop: 22 }}
          icon={"credit-card"}
          onChangeText={(text) => {
            setNumeroCartao(text);
          }}
          width={"100%"}
          placeholder="0000 0000 0000 0000"
          helperText={mensagemErro}
          bg={"#fff"}
          estiloNovo={{ rotulo: "Número do cartão", corFoco, erro: erroCampo }}
          // onFocus={() => setFocusInput("number")}
        />
      );
    }

    if (etapaCartao === "nome-cartao") {
      return (
        <Input
          colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
          corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
          value={nomeCartao}
          icon={"person"}
          onChangeText={(text) => {
            setNomeCartao(text);
          }}
          width={"100%"}
          styleBox={{ marginTop: 22 }}
          placeholder="Como está escrito no cartão"
          helperText={mensagemErro}
          bg={"#fff"}
          estiloNovo={{
            rotulo: "Nome impresso no cartão",
            corFoco,
            erro: erroCampo,
          }}
          // onFocus={() => setFocusInput("name")}
        />
      );
    }

    if (etapaCartao === "validade-cartao") {
      return (
        <Input
          colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
          corBordaFiltro={"#e2e8f0"}
          mask="99/99"
          value={validadeCartao}
          styleBox={{ marginTop: 22 }}
          icon={"calendar-today"}
          onChangeText={(text) => {
            setValidadeCartao(text);
          }}
          width={"100%"}
          placeholder="MM/AA"
          helperText={mensagemErro}
          bg={"#fff"}
          estiloNovo={{ rotulo: "Validade", corFoco, erro: erroCampo }}
          // onFocus={() => setFocusInput("expiry")}
        />
      );
    }

    return (
      <Input
        colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
        corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
        width={"100%"}
        styleBox={{ marginTop: 22 }}
        placeholder={"000"}
        helperText={mensagemErro || "Os 3 ou 4 números no verso do cartão."}
        value={cvv}
        icon={"lock"}
        type="number"
        onChangeText={(text) => {
          if (text.length > 4) {
            return;
          }
          setCvv(text);
        }}
        bg={"#fff"}
        estiloNovo={{
          rotulo: "Código de segurança (CVV)",
          corFoco,
          erro: erroCampo,
        }}
        // onFocus={() => setFocusInput("cvc")}
      />
    );
  };

  // indicador das partes do cartão (só exibição, calculado do etapaCartao)
  const PARTES_CARTAO = [
    { chave: "numero-cartao", rotulo: "Número" },
    { chave: "nome-cartao", rotulo: "Nome" },
    { chave: "validade-cartao", rotulo: "Validade" },
    { chave: "cvv", rotulo: "CVV" },
  ];
  const indiceParteAtual = PARTES_CARTAO.findIndex(
    (parte) => parte.chave === etapaCartao,
  );
  const corIndicador = corFoco || "#1E7B3C";

  const renderIndicadorPartes = () => (
    <RNView
      style={{
        flexDirection: "row",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 6,
        marginTop: 18,
      }}
    >
      {PARTES_CARTAO.map((parte, indice) => {
        const atual = indice === indiceParteAtual;
        const concluida = indice < indiceParteAtual;

        return (
          <RNView
            key={parte.chave}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 4,
              paddingVertical: 5,
              paddingHorizontal: 11,
              borderRadius: 14,
              borderWidth: 1,
              borderColor: atual ? corIndicador : "rgba(0,0,0,0.08)",
              backgroundColor: atual
                ? corIndicador
                : concluida
                  ? "#fff"
                  : "transparent",
            }}
          >
            {concluida && (
              <Feather name="check" size={11} color={corIndicador} />
            )}
            <RNText
              style={{
                fontSize: 11,
                fontWeight: "700",
                color: atual
                  ? corTextoSobre(corIndicador)
                  : concluida
                    ? corIndicador
                    : "#b5b0a6",
              }}
            >
              {parte.rotulo}
            </RNText>
          </RNView>
        );
      })}
    </RNView>
  );

  return (
    <>
      <Box style={{ width: "100%" }}>
        <Box
          style={{
            marginTop: 4,
            alignItems: "center",
          }}
        >
          <Cards
            number={numeroCartao}
            expiry={validadeCartao}
            cvc={cvv}
            name={nomeCartao}
            placeholders={{
              name: "Nome no Cartão",
            }}
            locale={{ valid: "Válido até" }}
            preview={false}
            focused={focusInput}
          />
        </Box>
        {renderIndicadorPartes()}
        {renderInputAtual()}
        {/* Os botões Voltar / Próximo / Finalizar passaram para a moldura
            (topo "‹" e botão do rodapé) via acoesRef, com as mesmas funções. */}
      </Box>
    </>
  );
};

export default DadosPagamento;
